import React, { useEffect, useRef, useState } from "react";

const CardLoader = ({setCardLoaderWidth}) => {
    const cardRef = useRef(null);
    

    useEffect(() => {
        if (!cardRef.current) return;

        const updateWidth = () => {
            setCardLoaderWidth(cardRef?.current?.offsetWidth);
        };

        const observer = new ResizeObserver(updateWidth);
        observer.observe(cardRef.current);

        updateWidth();

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={cardRef} className="w-full h-full aspect-[1/1] flex flex-col gap-2">
            <div className="relative bg-gray-light w-full h-full overflow-hidden">
                <div className="absolute bg-white w-[70px] h-full animate-slide blur-3xl" />
            </div>
        </div>
    );
};

export default CardLoader;